import { render, staticRenderFns } from "./add-classification.vue?vue&type=template&id=74332b88&scoped=true&"
import script from "./add-classification.vue?vue&type=script&lang=js&"
export * from "./add-classification.vue?vue&type=script&lang=js&"
import style0 from "./add-classification.vue?vue&type=style&index=0&id=74332b88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74332b88",
  null
  
)

export default component.exports